import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import ListPostgraduateCourses from "./List";
import CreatePostgraduateCourses from "./Create";
import EditPostgraduateCourses from "./Edit";
import ShowPostgraduateCourses from "./Show";
import { POSTGRADUATE_COURSES, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <LocalLibraryIcon />,
  name: SpecialistServicePath + POSTGRADUATE_COURSES,
  title: "Следдипломни курсове",
  list: <ListPostgraduateCourses />,
  show: <ShowPostgraduateCourses />,
  create: <CreatePostgraduateCourses />,
  edit: <EditPostgraduateCourses />,
  permission: permissions.canPreviewSpecialistPostgraduateCourses,
  showPermission: permissions.canPreviewSpecialistPostgraduateCourses,
  createPermission: permissions.canManageSpecialistPostgraduateCourses,
  editPermission: permissions.canManageSpecialistPostgraduateCourses,
};
